import { render, staticRenderFns } from "./RequiredMaterialsView.vue?vue&type=template&id=171eaeae&scoped=true"
import script from "./RequiredMaterialsView.vue?vue&type=script&lang=js"
export * from "./RequiredMaterialsView.vue?vue&type=script&lang=js"
import style0 from "./RequiredMaterialsView.vue?vue&type=style&index=0&id=171eaeae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "171eaeae",
  null
  
)

export default component.exports